/**
 * Query params d'une lecture de table.
 *
 * Les champs envoyés sont **dérivés des `controls` du descripteur**, jamais
 * listés en dur : c'est exactement la définition d'axe donnée qu'utilise
 * `tableConfigDataAxisChanged` pour décider d'un refetch. Avec une liste en
 * dur, un axe déclaré dans le descripteur mais oublié ici déclenchait un
 * refetch avec une URL identique — le backend retombait sur sa valeur par
 * défaut et le réglage restait sans effet.
 *
 * Module partagé document ↔ site : pur, sans React ni store.
 */

import { getTableConfigControls } from './tableDescriptors';

export const buildTableQuery = ({ tableName, split, tableConfig, catalog, force }) => {
  const params = new URLSearchParams();
  if (split) params.set('split', 'true');
  if (catalog) params.set('catalog', 'true');
  // force=true : régénère les screenshots de planning même s'ils existent déjà
  // (bouton "Mettre à jour"). Ignoré par les tableaux non planning.
  if (force) params.set('force', 'true');
  if (tableConfig) {
    getTableConfigControls(tableName).forEach(({ field, themeField }) => {
      // Axe "style" : c'est la copie des couleurs figée sur la box qui part au
      // backend, pas l'empreinte qui sert seulement à détecter le changement.
      if (themeField) {
        const theme = tableConfig[themeField];
        if (theme) params.set(themeField, JSON.stringify(theme));
        return;
      }
      const value = tableConfig[field];
      if (value === undefined || value === null) return;
      params.set(field, typeof value === 'boolean' ? String(value) : value);
    });
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
};
